<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="images/p5.jpg"/><a id="page_5"></a></p><a id="page_5">
<p class="fm1"><b>Bryan Lubic, M.A., J.D., CCMC, CJSS</b></p>
<p class="txc">(650) 427-9265</p>
</a><p class="txc"><a id="page_5"></a><a href="mailto:bryanlubic@gmail.com" id="AiD">bryanlubic@gmail.com</a></p>
<p class="txc"><a href="http://linkedin.com/in/bryanlubic" id="A3u" target="_blank">linkedin.com/in/bryanlubic</a></p>
<p class="txt1">Bryan Lubic is a strengths-based career and professional development practitioner with a background in the leadership and administration of career services in higher education. He earned certifications as a Certified Career Management Coach (CCMC) and Certified Job Search Specialist (CJSS) and has completed advanced training in helping people identify, connect, and communicate their amazing value to potential employers easily and effectively.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter06.vue?188a6346